import React from "react";
import { useTranslation } from "react-i18next";

import { SelectedResourcesList } from "./selectedResourcesList";
import { Props } from "./types";
import styles from "./styles.scss";

function ResourceSelection(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.firstInput}>
      <h2>{t("addPlanzoneResourceToProject.input_one")}</h2>
      <div className={styles.form}>
        <SelectedResourcesList
          selectedResources={props.selectedResources}
          selectResources={props.selectResources}
          roles={props.roles}
          selectRole={props.selectRole}
          project={props.project}
          isEveryoneSelected={props.isEveryoneSelected}
          selectEveryone={props.selectEveryone}
        />
      </div>
    </div>
  );
}

export { ResourceSelection };
